"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Text_meta_1 = require("../Text.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

var withSelector_1 = require("../../../../shared/withSelector");

var Content = function Content(props) {
  var className = props.className,
      _a = props.children,
      children = _a === void 0 ? '' : _a;
  var Section = withSelector_1.withSelector('section', props);
  return react_1.default.createElement(Section, {
    role: 'text',
    className: className
  }, children);
};

exports.default = InjectedStyledComponent_1.InjectedStyledComponent(Content, Text_meta_1.TEXT_CATEGORY_KEY, Text_meta_1.TEXT_COMPONENT_KEY, ['content']);